import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import {Accordion, AccordionDetails } from "@mui/material";
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { Grid, Typography, Popover } from '@mui/material';
import Logos from '../images/Logos.png';
import Paper from '@mui/material/Paper';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import BotaoDec from '../components/BotaoDec'
import BotaoValores from '../components/BotaoValores'
import BotaoCertidoes from "../components/BotaoCertidoes";
import BotaoOrientacoes from '../components/BotaoOrientacoes';

const drawerWidth = 240;

const theme = createTheme();

const navItems = [
    { route: '/programacao', text: 'Programação' },
    { route: '/galeria', text: 'Galeria' },
    { popover: true, text: 'Dúvidas' },
    { route: 'https://credmarcha.cnm.org.br/', text: 'Certificados XXV Marcha' },
];

export default function Nowhere(props) {
    const { window } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [popoverAnchor, setPopoverAnchor] = React.useState(null);

    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    const handlePopoverOpen = (event) => {
        setPopoverAnchor(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setPopoverAnchor(null);
    };


    // const drawer = (
    //     <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
    //         <List>
    //             {navItems.map((item) => (
    //                 <ListItem key={item.text} disablePadding>
    //                     <ListItemButton sx={{ textAlign: 'center' }}>
    //                         <Link to={item.route} style={{ textDecoration: 'none', color: 'inherit' }}>
    //                             <ListItemText primary={item.text} />
    //                         </Link>
    //                     </ListItemButton>
    //                 </ListItem>
    //             ))}
    //         </List>
    //     </Box>
    // );

    const container = window !== undefined ? () => window().document.body : undefined;

    const handleSubmit = (event) => {
        event.preventDefault();
    };

    return (
        <>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <AppBar
                    component="nav"
                    sx={{
                        backgroundColor: '#002758',
                        borderBottom: 0,
                        boxShadow: 'none',
                        position: 'static'
                    }}
                >
                    <Toolbar
                        sx={{
                            // display: 'flex',
                            // justifyContent: 'center',
                            // alignItems: 'center',
                            height: '18vh',
                            margin: '0 5% 0 5%',
                        }}
                    >
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{ mr: 2, display: { sm: 'none' } }}
                        >
                            <MenuIcon /> MENU
                        </IconButton>

                        <Box sx={{ display: { xs: 'inline', sm: 'none' }, marginRight: 'auto' }}>
                            <Link to="/">
                                <img src={Logos} alt="Logos CNM e XXVI Marcha" style={{ width: '200px' }} />
                            </Link>
                        </Box>
                        <Grid sx={{ flexGrow: 1, display: { xs: 'none', sm: 'inline' } }}>
                            <Link to="/">
                                <img src={Logos} alt="Logos CNM e XXVI Marcha" style={{ width: '50%' }} />
                            </Link>
                        </Grid>

                        <Box sx={{ display: { xs: 'none', md: 'inline', sm: 'inline' } }}>
                            {navItems.map((item, index) => {
                                if (!item.popover) {
                                    return (
                                        <Button
                                            key={item.text}
                                            sx={{
                                                color: '#fff',
                                                fontSize: { xl: '1rem', lg: '0.8rem' },
                                                textTransform: 'none',
                                                ...(index === navItems.length - 1 && {
                                                    backgroundColor: '#FFBE00',
                                                    color: 'success.contrastText',
                                                    borderRadius: '11px',
                                                    paddingX: '15px',
                                                }),
                                            }}
                                            component={Link}
                                            to={item.route}
                                            target={index === navItems.length - 1 ? '_blank' : undefined}
                                            rel={index === navItems.length - 1 ? 'noopener noreferrer' : undefined}
                                        >
                                            {item.text}
                                        </Button>
                                    );
                                } else {
                                    return (
                                        <React.Fragment key={item.text}>
                                            <Popover
                                                id="duvidas-popover"
                                                open={Boolean(popoverAnchor)}
                                                anchorEl={popoverAnchor}
                                                onClose={handlePopoverClose}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                            >
                                                <List>
                                                    <ListItem disablePadding>
                                                        <BotaoDec />
                                                    </ListItem>
                                                    <ListItem disablePadding>
                                                        <BotaoValores />
                                                    </ListItem>                                                     
                                                    <ListItem disablePadding>
                                                        <BotaoCertidoes />
                                                    </ListItem>
                                                    <ListItem disablePadding>
                                                        <BotaoOrientacoes />
                                                    </ListItem>
                                                </List>
                                            </Popover>
                                            <Button
                                                aria-describedby={popoverAnchor ? 'duvidas-popover' : undefined}
                                                onClick={handlePopoverOpen}
                                                sx={{
                                                    color: '#fff',
                                                    fontSize: { xl: '1rem', lg: '0.8rem' },
                                                    textTransform: 'none',
                                                    ...(index === navItems.length - 1 && {
                                                        backgroundColor: '#FFBE00',
                                                        color: 'success.contrastText',
                                                        borderRadius: '11px',
                                                        paddingX: '15px',
                                                    }),
                                                }}
                                            >
                                                {item.text}
                                            </Button>
                                        </React.Fragment>
                                    );
                                }
                            })}
                        </Box>

                    </Toolbar>
                </AppBar>
                <nav>
                    <Drawer
                        container={container}
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true,
                        }}
                        sx={{
                            display: { xs: 'block', sm: 'none' },
                            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                        }}
                    >
                        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
                            <List>
                                {navItems.map((item) => (
                                    <ListItem key={item.text} disablePadding>
                                        <ListItemButton sx={{ textAlign: 'center' }}>
                                            {item.popover ? (
                                                <Accordion>
                                                    <AccordionDetails>
                                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                            <BotaoDec />
                                                            <BotaoValores />
                                                            <BotaoCertidoes />
                                                            <BotaoOrientacoes />
                                                        </div>
                                                    </AccordionDetails>
                                                </Accordion>
                                            ) : (
                                                <Link to={item.route} style={{ textDecoration: 'none', color: 'inherit' }}>
                                                    <ListItemText primary={item.text} />
                                                </Link>
                                            )}
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    </Drawer>
                </nav>
            </Box>

            <ThemeProvider theme={theme}>
                <Grid container component="main" sx={{ height: '80vh' }}>
                    <CssBaseline />
                    <Grid
                        item
                        xs={false}
                        sm={4}
                        md={7}
                        sx={{
                            backgroundImage: 'url(https://source.unsplash.com/random)',
                            backgroundRepeat: 'no-repeat',
                            backgroundColor: (t) =>
                                t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                        }}
                    />
                    <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                        <Box
                            sx={{
                                marginTop: 20,
                                marginLeft: 4,
                                marginRight: 4,
                                marginBottom: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}
                        >
                            <Typography variant="h1" color="inherit" className="font-medium mb-16">
                                404
                            </Typography>
                            <Box component="form" style={{ textAlign: 'center' }} noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
                                <Typography variant="h5" color="textSecondary" className="mb-16">
                                    A página solicitada não foi encontrada.
                                </Typography>
                                <Typography variant="h5" color="textSecondary" className="mb-16">
                                    {':('}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </ThemeProvider>
        </>
    );
}

